<div class="flex-1 flex flex-col overflow-hidden">
  <!-- Edit Content -->
  <main class="flex-1 overflow-y-auto p-6">
    <!-- Back Navigation and Title -->
    <div class="flex justify-between items-baseline mb-3">
      <button (click)="cancel()" class="flex items-center">
        <i class="pi pi-arrow-left me-3"></i>
        Edit Document
      </button>

      <!-- Step Indicator -->
      <div class="mb-6 flex justify-end">
        <div
          class="bg-white border border-dashed border-gray-300 px-4 py-2 rounded-lg"
        >
          <span class="text-gray-800 text-sm font-medium">
            Step:
            <span class="text-purple-600">02</span>/<span class="text-gray-800"
              >02</span
            >
          </span>
        </div>
      </div>
    </div>

    <!-- Main Content Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <!-- Left Side - User Assignment Form (Step 2) -->
      <div class="space-y-6">
        <form [formGroup]="step2Form" class="space-y-6">
          <!-- Users FormArray -->
          <div formArrayName="users" class="space-y-6">
            @for (userGroup of usersFormArray.controls; track $index; let i =
            $index) {
            <div
              [formGroupName]="i"
              class="p-4 border border-gray-200 rounded-lg bg-gray-50"
            >
              <div class="flex justify-between items-center mb-4">
                <h4 class="text-sm font-medium text-gray-700">
                  Select User {{ (i + 1).toString().padStart(2, "0") }}
                </h4>
                @if (usersFormArray.length > 1) {
                <button
                  type="button"
                  (click)="removeUser(i)"
                  class="text-red-500 hover:text-red-700 text-sm"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
                }
              </div>

              <!-- User Selection -->
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Select User
                </label>
                <div class="relative">
                  <select
                    formControlName="userId"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent appearance-none bg-white"
                    [class.border-red-500]="
                      userGroup.get('userId')?.invalid &&
                      userGroup.get('userId')?.touched
                    "
                  >
                    <!-- <option value="">Select User</option> -->
                    @for (user of userOptions; track user.value) {
                    <option
                      [value]="user.value"
                      [disabled]="user.value === null"
                    >
                      {{ user.label }}
                    </option>
                    }
                  </select>
                  <svg
                    class="absolute right-3 top-2.5 w-5 h-5 text-gray-400 pointer-events-none"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </div>
                @if (userGroup.get('userId')?.invalid &&
                userGroup.get('userId')?.touched) {
                <div class="text-red-500 text-sm mt-1">
                  User selection is required
                </div>
                }
              </div>

              <!-- Permission Selection -->
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Add Permission
                </label>
                <p-select
                  formControlName="permission"
                  [options]="permissionOptions"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="
                    isLoadingPermissions
                      ? 'Loading permissions...'
                      : 'Select Permission'
                  "
                  [disabled]="isLoadingPermissions"
                  class="w-full"
                  [class.ng-invalid]="
                    userGroup.get('permission')?.invalid &&
                    userGroup.get('permission')?.touched
                  "
                ></p-select>
                @if (userGroup.get('permission')?.invalid &&
                userGroup.get('permission')?.touched) {
                <div class="text-red-500 text-sm mt-1">
                  Permission selection is required
                </div>
                }
              </div>
            </div>
            }
          </div>

          <!-- Add New User Button -->
          <div class="pt-4">
            <button
              type="button"
              (click)="addUser()"
              class="flex items-center px-4 py-2 text-sm font-medium border rounded-lg transition-colors"
              style="
                border-color: var(--color-table-header);
                background: none;
                color: inherit;
              "
            >
              + Add New User
            </button>
          </div>
        </form>
      </div>

      <!-- Right Side - Document Details -->
      <div class="flex flex-col">
        <div class="bg-white border border-gray-200 rounded-lg p-6 space-y-6">
          <h3 class="text-lg font-medium text-gray-900 mb-4">
            Document Details
          </h3>

          <!-- Document Name -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Document Name</label
            >
            <div
              class="text-sm text-gray-900 bg-gray-50 px-3 py-2 rounded border"
            >
              {{ step1Form.get("documentName")?.value }}
            </div>
          </div>

          <!-- Upload Date -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Upload Date</label
            >
            <div
              class="text-sm text-gray-900 bg-gray-50 px-3 py-2 rounded border"
            >
              {{ step1Form.get("dueDate")?.value | date : "dd/MM/yyyy" }}
            </div>
          </div>

          <!-- Due Date -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Due Date</label
            >
            <div
              class="text-sm text-gray-900 bg-gray-50 px-3 py-2 rounded border"
            >
              {{ step1Form.get("dueDate")?.value | date : "dd/MM/yyyy" }}
            </div>
          </div>

          <!-- Workflow Type -->
          <div>
            <!-- <label class="block text-sm font-medium text-gray-700 mb-2"
                >Workflow Type</label
              > -->
            <!-- <div
                class="text-sm text-gray-900 bg-gray-50 px-3 py-2 rounded border"
              >
                Approval
              </div> -->
          </div>

          <!-- Document Display -->
          <div
            class="text-white p-4 rounded-lg"
            [style.background-color]="'var(--color-background-document)'"
          >
            <div class="flex items-center justify-between">
              <span class="text-sm font-medium">
                {{
                  step1Form.get("documentName")?.value ||
                    "Document Name XYZ.PDF"
                }}
              </span>
              <button
                type="button"
                class="text-[13px] font-semibold underline"
                style="
                  color: var(--color-primary-red);
                  background: none;
                  border: none;
                  cursor: pointer;
                "
              >
                View Document
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-end space-x-4 mt-8">
      <button
        type="button"
        (click)="cancel()"
        class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="submitForm()"
        class="px-6 py-2 text-white rounded-lg transition-colors"
        [style.background]="(canSubmit && !loading) ? 'var(--color-table-header)' : '#9ca3af'"
        [style.color]="'white'"
        [style.cursor]="(canSubmit && !loading) ? 'pointer' : 'not-allowed'"
        [style.opacity]="(canSubmit && !loading) ? '1' : '0.6'"
        [disabled]="!canSubmit || loading"
      >
        @if (loading) {
        <span
          class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
        ></span>
        }
        {{ loading ? "Updating..." : "Update Document" }}
      </button>
    </div>
  </main>
  <!-- Toast Messages -->
  <p-toast></p-toast>
</div>
